module.exports = __webpack_public_path__ + "static/media/darkCheckBox.d805bc92.svg";